import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Link } from 'react-router-dom';
import { getTestIds } from '../../../../../utils/TestIds';
import { Row } from '../../../../Layout';
import { Typography } from '../../../../Typography';
import styles from '../cells.module.scss';
import { asLinkEntries } from './LinkCell.utils';
export function LinkCell(param) {
    let { value, emptyText, testId } = param;
    const testIds = getTestIds(testId);
    const entries = asLinkEntries(value);
    if (entries.length === 0) {
        return /*#__PURE__*/ _jsx(Typography, {
            ellipsis: true,
            skin: "disabled",
            testId: testId,
            children: emptyText
        });
    }
    return /*#__PURE__*/ _jsx(Row, {
        alignItems: "center",
        gap: 0,
        wrap: true,
        className: styles.linkLines,
        testId: testIds.lines(),
        children: entries.map((entry, index)=>/*#__PURE__*/ _jsx("span", {
                className: styles.linkItem,
                children: /*#__PURE__*/ _jsx(Typography, {
                    ellipsis: true,
                    as: Link,
                    to: entry.to,
                    skin: "primary",
                    className: styles.link,
                    testId: testIds.link(index),
                    children: entry.label
                })
            }, "".concat(entry.to, "-").concat(index)))
    });
}
